import { getSessionData } from "@repo/shared-utils/common-utils";
import { IResponse, encryptedRequest } from "../auth/api";
import { decryptLocalStorageMobileNo } from "@repo/shared-utils/crypto";
import { API_PATHS } from "../constants/api.constants";
import { COMMON_SSO_MOBILE } from "../constants/sso.constants";
import { LogUtils } from "@repo/shared-utils/log-utils";

export interface IApiResponseConsentRead {
  data: Record<string, null>;
  statusCode: number;
  status: string;
  message: string;
}

export interface IApiResponseConsentInsert {
  data: Record<string, unknown> | null;
  statusCode: number;
  status: string;
  message: string;
}

export const consentRead = async (
  partnerName: string,
  partnerId: string,
  consentCategory: string
): Promise<IResponse<Record<string, unknown>>> => {
  try {
    let mobileNumFromSession = "";
    const localStorageMobileNo = localStorage.getItem(COMMON_SSO_MOBILE);
    mobileNumFromSession = await decryptLocalStorageMobileNo(localStorageMobileNo || "");

    const response = await encryptedRequest<Record<string, undefined>>({
      method: "POST",
      url: API_PATHS.consentRead,
      data: {
        mobileNo: mobileNumFromSession,
        partnerName: partnerName ?? "",
        partnerId: partnerId ?? "",
        consentCategory: consentCategory ?? "",
      },
    });
    if ([90, 91, 92].includes(response?.statusCode)) {
      return response;
    }
    return {} as IResponse<Record<string, unknown>>;
  } catch (err) {
    LogUtils.error("Error in ssoRedirect:", err);

    throw err;
  }
};

export const consentInsert = async (
  partnerName: string,
  consentCategory: string,
  consentStatus: boolean
): Promise<IResponse<Record<string, unknown>>> => {
  try {
    let mobileNumFromSession = "";
    let custIdFromSession = "";
    let firstNameSession = "";
    let lastNameSession = "";
    let custTypeSession = "";
    const localStorageMobileNo = localStorage.getItem(COMMON_SSO_MOBILE);
    const mobileNo = await decryptLocalStorageMobileNo(localStorageMobileNo || "");
    const { custId, custType, firstName, lastName } = await getSessionData();
    mobileNumFromSession = mobileNo;
    custIdFromSession = custId ?? "";
    firstNameSession = firstName ?? "";
    lastNameSession = lastName ?? "";
    custTypeSession = custType ?? "";

    const response = await encryptedRequest<Record<string, unknown>>({
      method: "POST",
      url: API_PATHS.consentInsert,
      data: {
        mobileNo: mobileNumFromSession,
        partnerName: partnerName ?? "",
        consentCategory: consentCategory ?? "",
        consentStatus,
        custId: custIdFromSession,
        ...(custTypeSession === "ETB"
          ? { firstName: firstNameSession, lastName: lastNameSession }
          : {}),
      },
    });
    if ([90, 91, 92].includes(response?.statusCode)) {
      return response;
    }
  } catch (err) {
    LogUtils.error("Error in consent-insert API:", err);
    throw err;
  }
  return {} as IResponse<Record<string, unknown>>;
};
